/* Stops "Add to cart" from skipping the cart.

   THE BUG (reported live, 11 Aug): Add to cart went STRAIGHT to checkout. Every buy form
   on the PDP carried a hidden field:
       <input type="hidden" name="return_to" value="/checkout">
   Shopify honours return_to after POST /cart/add, so the shopper never saw a cart, could
   not add a second item, and never saw the bundle upsell. Removing that field restores the
   normal destination (/cart).

   Done at runtime rather than in the section file because the PDP section is 26KB and is
   rebuilt by luma-fx.js — a static edit would be undone on the next redraw. Re-runs on
   mutation for the same reason. Only checkout-bound return_to values are removed. */
(function(){
  function strip(){
    document.querySelectorAll('form[action*="/cart/add"] input[name="return_to"]').forEach(function(i){
      var v = (i.getAttribute('value') || '').trim();
      if (/^\/?checkout/i.test(v)) i.parentNode.removeChild(i);
    });
  }
  strip();
  document.addEventListener('DOMContentLoaded', strip);
  window.addEventListener('load', strip);
  [200, 700, 1600, 3000].forEach(function(d){ setTimeout(strip, d); });
  function observe(){
    if (!document.body) return;
    var q = false;
    new MutationObserver(function(){
      if (q) return; q = true;
      requestAnimationFrame(function(){ q = false; strip(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) observe(); else document.addEventListener('DOMContentLoaded', observe);
})();